import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=e1aa0482&scoped=true"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"
import style0 from "./index.sass?vue&type=style&index=0&id=e1aa0482&prod&scoped=true&lang=sass&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1aa0482",
  null
  
)

export default component.exports